import { postJson } from '../../../common/data/common-data-service';
import { ITodoTitleChartResponse } from '../todo-title-chart-interfaces';

export const getTodoTitleChartData = async (todo_id: number) : Promise<ITodoTitleChartResponse> => {
    return await postJson(`/api/todo-title-chart/chart-data`, {
        todo_id,
    });
};